import { FC } from 'react'
import { IonButtons } from '@ionic/react'

import { ChatButton } from '@/components/molecules/ChatButton'
import { CurrencyBalanceButton } from '@/components/molecules/CurrencyBalanceButton'

import { IWallet } from '@/services/wallet/getWallet'

import { Pages } from '@/enums'

interface IHeader {
  wallet: IWallet
  scrollToTop: () => void
}

export const Header: FC<IHeader> = ({ scrollToTop, wallet }) => {
  return (
    <div className="flex flex-row justify-between py-2.5 pl-3">
      <img src="/logo-icon.svg" alt="republik" onClick={() => scrollToTop()} />
      <IonButtons slot="end">
        <CurrencyBalanceButton wallet={wallet} />
        <ChatButton className="!ml-1" page={Pages.Feed} />
      </IonButtons>
    </div>
  )
}
